import { render } from "./app-navbar.vue?vue&type=template&id=900380bc&scoped=true"
import script from "./app-navbar.vue?vue&type=script&lang=js"
export * from "./app-navbar.vue?vue&type=script&lang=js"

import "./app-navbar.vue?vue&type=style&index=0&id=900380bc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-900380bc"],['__file',"src/views/components/layout/app-navbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "900380bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('900380bc', __exports__)) {
    console.log('reload')
    api.reload('900380bc', __exports__)
  }
  
  module.hot.accept("./app-navbar.vue?vue&type=template&id=900380bc&scoped=true", () => {
    console.log('re-render')
    api.rerender('900380bc', render)
  })

}


export default __exports__